import { getSelectedSiteIds } from './get-selected-site-ids';
export const isSiteSelected = (siteId) => getSelectedSiteIds().includes(siteId);
//# sourceMappingURL=is-site-selected.js.map